// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"561680e0","239":"6fb3a878","453":"10ca9c13","667":"fee5d9ea"}[chunkId] + ".chunk.js";
};